$(function () {
  let serviceDetailContainers = [...document.querySelectorAll(".service-details")];
	serviceDetailContainers.forEach(container => {
		const cards = [...container.querySelectorAll(".service-details__card")];
		const expandingCards = cards.filter(card => card.matches(".service-details__card--expand") && !!card.querySelector(".service-details__card-expander"));

		const returnSameRow = card => {
			let row = [];
			let top = card.getBoundingClientRect().top;
			cards.forEach(c => {
				if (c.getBoundingClientRect().top > (top - 8) && c.getBoundingClientRect().top < (top + 8)) {
					row.push(c);
				}
			});
			return row;
		}

		const adjustSpacing = card => {
			const expanderElement = card.querySelector(".service-details__card-expander");
			const row = [...returnSameRow(card)];
			const expanderHeight = expanderElement.offsetHeight;
			const gap = expanderElement.getBoundingClientRect().top - card.getBoundingClientRect().bottom;
			row.forEach(card => card.style.marginBottom = expanderHeight + gap + "px");
		}

		const collapseCard = (card, trigger) => {
			card.classList.remove("card--expanded");
			trigger.setAttribute("aria-label", "Expand service information");
			[...returnSameRow(card)].forEach(card => card.style.marginBottom = "");
		}

		const expandCard = card => {
			// block below adjusts the position of expanding dropdown so
			// the ones on the right are centered appropriately
			const expanderElement = card.querySelector(".service-details__card-expander");
			const containerLeft = container.getBoundingClientRect().left;
			const cardLeft = card.getBoundingClientRect().left;
			const leftOffset = containerLeft - cardLeft + "px";
			expanderElement.style.left = leftOffset;

			const openCard = container.querySelector(".card--expanded");
			if (!!openCard) collapseCard(openCard, openCard.querySelector(".service-details__card-expander"));
			
			// block below sets/limits width of expanding dropdown to container width
			const fullWidth = container.offsetWidth;
			expanderElement.style.width = fullWidth + "px";
			expanderElement.style.maxWidth = fullWidth + "px";
			
			card.classList.add("card--expanded");
			adjustSpacing(card);
		}

		expandingCards.forEach(card => {
			const trigger = card.querySelector("a.service-details__card-inner");
			const close = card.querySelector("button.service-details__card-expander-close");

			trigger.setAttribute("aria-label", "Expand service information");

			if (!!trigger) {
				trigger.addEventListener("click", e => {
					e.preventDefault();
					if (card.matches(".card--expanded")) collapseCard(card, trigger);
					else expandCard(card);
				});
			}
			if (!!close) {
				close.addEventListener("click", e => {
					e.preventDefault();
					collapseCard(card, trigger);
				});
			}
		})
  });
});